import { Link } from 'react-router-dom';

import Button from '@/shared/components/UI/Button';
import Modal from '@/shared/components/UI/Modal';

interface ContinueShoppingModalProps {
  isOpen: boolean;
  onClose: () => void;
  onContinueShopping: () => void;
}

const ContinueShoppingModal = ({
  isOpen,
  onClose,
  onContinueShopping,
}: ContinueShoppingModalProps) => {
  if (!isOpen) return null;

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="md" titleAlign="center">
      <p className="mb-4 text-[18px] font-bold text-[#1d1d1d]">
        Added to Cart!
      </p>

      <p className="mb-6 text-[14px] text-[#666]">
        Your item has been successfully added to your cart.
      </p>

      <div className="flex justify-center gap-3">
        <Button
          type="button"
          onClick={onContinueShopping}
          variant="secondary"
          size="md"
          className="px-6 py-3"
        >
          Continue Shopping
        </Button>
        <Link to="/cart">
          <Button variant="primary" size="md" className="px-6 py-3">
            View Cart
          </Button>
        </Link>
      </div>
    </Modal>
  );
};

export default ContinueShoppingModal;
